export const complainStatus = [
  { key: '未處理', label: '未處理', value: 0 },
  { key: '處理中', label: '處理中', value: 1 },
  { key: '處理完成', label: '處理完成', value: 2 },
  { key: '全部', label: '全部', value: 'all' },
]



// WEBPACK FOOTER //
// ./src/constants/customerComplain.js